export const formatSnakeCase = (input: string): string => {
  if (!input) return input

  // Replace underscores with spaces and convert to lower case.
  const lowerCased = input.replace(/_/g, ' ').toLowerCase()
  // Capitalize the first letter of the resulting string.
  return lowerCased.charAt(0).toUpperCase() + lowerCased.slice(1)
}

export const formatToIpfsUrl = (hash: string): string =>
  hash.startsWith('ipfs://') ? hash : `ipfs://${hash}`
